export const tickerItems = [
  "线索墙更新：本周新增 37 条待核实投稿",
  "社团经费明细对照已出第一版，欢迎补充材料",
  "提醒：请勿在评论区公开他人真实信息",
  "「已澄清」标记本日新增 4 条，原内容已同步更新",
  "宿舍矛盾事件双方已提交澄清材料，正在核对",
  "兼职押金问题汇总贴已更新至第 3 版",
  "社区提示：未经证实的内容请当作线索而非结论",
  "旧瓜复盘专题上线，方便新同学补齐背景",
];

export const hotRanking = [
  { rank: 1, title: "某高校社团会长私聊记录被扒，多段语音流出", tag: "实锤", heat: "12.8万", trend: "up" },
  { rank: 2, title: "疑似同校学弟被指借作业牟利，截图对比引发争议", tag: "爆料", heat: "9.4万", trend: "up" },
  { rank: 3, title: "女生宿舍矛盾升级，双方各执一词争论持续三天", tag: "讨论", heat: "8.1万", trend: "flat" },
  { rank: 4, title: "某专业期末成绩异常，学生实名质疑流程引围观", tag: "校园", heat: "7.6万", trend: "up" },
  { rank: 5, title: "学生会竞选内定传闻，当事人发文回应", tag: "翻车", heat: "6.9万", trend: "down" },
  { rank: 6, title: "网络代写被曝重复收稿，多名学生投稿反映", tag: "黑历史", heat: "5.8万", trend: "up" },
  { rank: 7, title: "毕业照互撕事件后续：双方达成和解", tag: "后续", heat: "4.2万", trend: "flat" },
  { rank: 8, title: "匿名投稿被指断章取义，社区发起核查", tag: "核查", heat: "3.5万", trend: "down" },
];

export const heroLead = {
  title: "「内部表」流出：社团经费去向追踪",
  summary: "从一张被反复转发的截图开始，社区同学用两周时间对照了公示版本，梳理出三处对不上的地方。",
  tag: "深度实锤",
  time: "今天 14:20",
  views: "18.6万围观",
  cover:
    "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20torn%20newsprint%20and%20paper%20clippings%20connected%20by%20red%20thread%20on%20a%20warm%20cream%20wall%2C%20dramatic%20side%20light%2C%20investigative%20documentary%20mood%2C%20muted%20terracotta%20and%20sand%20palette%2C%20no%20text%2C%20no%20people%2C%20high%20detail%20editorial%20photography&width=1200&height=760&seq=gossip-hero-lead-01&orientation=landscape",
};

export const confirmedStories = [
  {
    id: "story-1",
    title: "经费对照第二版：三处数字对不上",
    summary: "首版对照之后，社区又补上两份可核对的截图，把争议范围缩小到三处具体数字，等待更多材料。",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20paper%20ledger%20book%20with%20a%20fountain%20pen%20and%20a%20calculator%20on%20a%20warm%20wooden%20desk%2C%20soft%20window%20light%2C%20financial%20records%20concept%2C%20terracotta%20and%20sand%20tones%2C%20minimal%20editorial%20still%20life%2C%20no%20readable%20text%2C%20high%20detail&width=800&height=560&seq=gossip-story-ledger-07&orientation=landscape",
    tag: "深度实锤",
    time: "今天 14:20",
  },
  {
    id: "story-2",
    title: "一通电话引发的连锁反应",
    summary: "当事人自述与多位同学的说法存在出入，我们把时间线拉直，标出仍然空白的三段。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20landline%20telephone%20resting%20on%20a%20marble%20table%20with%20warm%20amber%20lighting%2C%20mysterious%20investigative%20atmosphere%2C%20minimal%20editorial%20still%20life%20photography%2C%20soft%20shadows%2C%20cream%20and%20sand%20background%2C%20high%20detail&width=800&height=560&seq=gossip-story-phone-02&orientation=landscape",
    tag: "时间线",
    time: "今天 11:05",
  },
  {
    id: "story-3",
    title: "线索墙：被红线圈住的六个疑点",
    summary: "匿名投稿、群聊记录、打卡截图……把零散线索钉在同一块墙上，哪些能对上，哪些对不上。",
    cover:
      "https://readdy.ai/api/search-image?query=Woven%20red%20threads%20pinning%20blank%20paper%20notes%20on%20a%20cork%20board%2C%20abstract%20investigative%20mood%2C%20warm%20cream%20and%20terracotta%20palette%2C%20clean%20minimal%20composition%2C%20editorial%20photography%2C%20no%20readable%20text%2C%20soft%20natural%20light&width=800&height=560&seq=gossip-story-board-03&orientation=landscape",
    tag: "线索墙",
    time: "昨天 21:40",
  },
];

export const newsBriefs = [
  {
    id: "brief-1",
    title: "「借教室占座」风波升级",
    summary: "有同学投稿称教学楼顶楼教室被长期占用，双方在评论区各执一词，目前尚无校方回应。",
    tag: "爆料",
    time: "12分钟前",
    source: "热心同学投稿",
    comments: 328,
  },
  {
    id: "brief-2",
    title: "社团经费明细被公开",
    summary: "一份被标记为「内部版」的经费表在群里流传，其中数笔支出用途存疑，社区已发起逐条核对。",
    tag: "实锤",
    time: "26分钟前",
    source: "匿名整理",
    comments: 214,
  },
  {
    id: "brief-3",
    title: "期末小组互评打分争议",
    summary: "小组作业互评环节被指存在抱团给分，多组同学晒出分数截图，质疑评分标准是否统一。",
    tag: "校园",
    time: "41分钟前",
    source: "课程组投稿",
    comments: 189,
  },
  {
    id: "brief-4",
    title: "表白墙投稿翻车实录",
    summary: "一条匿名表白稿被当事人要求撤下，评论区整理出前后矛盾的时间线，事件仍在发酵。",
    tag: "翻车",
    time: "1小时前",
    source: "评论区整理",
    comments: 156,
  },
  {
    id: "brief-5",
    title: "兼职中介押金问题汇总",
    summary: "多名学生反馈暑期兼职押金未退，社区汇总出可核对的聊天记录与转账截图，已联系投稿人补充。",
    tag: "汇总",
    time: "2小时前",
    source: "多人投稿",
    comments: 302,
  },
  {
    id: "brief-6",
    title: "宿舍查寝新规引热议",
    summary: "新规要求固定时段断电，同学在评论区讨论实际影响与应对方式，观点分歧相当明显。",
    tag: "讨论",
    time: "3小时前",
    source: "生活区投稿",
    comments: 98,
  },
  {
    id: "brief-7",
    title: "课程代跑传闻待核实",
    summary: "有投稿称存在有偿代跑现象，但目前缺乏直接证据，社区已提示谨慎传播、勿对号入座。",
    tag: "待核实",
    time: "4小时前",
    source: "匿名投稿",
    comments: 76,
  },
  {
    id: "brief-8",
    title: "旧瓜复盘：去年那场争论",
    summary: "整理去年同期的热议事件与后续进展，方便新来的同学快速补齐背景，避免二次误伤。",
    tag: "复盘",
    time: "5小时前",
    source: "社区编辑部",
    comments: 64,
  },
];

export const exposeItems = [
  {
    id: "expose-1",
    title: "「学长」人设翻车合集",
    category: "翻车",
    excerpt: "从答疑群到二手交易，前后说法不一致的片段被整理成一条清晰时间线。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20watercolor%20splash%20of%20vermilion%20and%20gold%20on%20textured%20cream%20paper%2C%20editorial%20art%2C%20calm%20minimal%20composition%2C%20warm%20earthy%20palette%2C%20subtle%20paper%20grain%2C%20no%20text%2C%20high%20detail&width=640&height=460&seq=gossip-expose-01&orientation=landscape",
    heat: "8.2k",
  },
  {
    id: "expose-2",
    title: "被扒：头像背后的另一个号",
    category: "被扒",
    excerpt: "两个账号的语气、错别字习惯高度相似，社区发起公开比对与核对。",
    cover:
      "https://readdy.ai/api/search-image?query=Folded%20newspaper%20stack%20lit%20by%20warm%20amber%20tone%20lighting%2C%20clean%20minimal%20still%20life%20on%20a%20sand%20paper%20background%2C%20editorial%20photography%2C%20soft%20shadows%2C%20no%20readable%20text%2C%20high%20detail&width=640&height=460&seq=gossip-expose-02&orientation=landscape",
    heat: "6.7k",
  },
  {
    id: "expose-3",
    title: "黑历史档案：三年言论回溯",
    category: "黑历史",
    excerpt: "公开可见的历史发言被按时间归档，并标注了当时的语境变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Desk%20lamp%20glowing%20over%20scattered%20handwritten%20notes%20in%20a%20dark%20room%2C%20warm%20amber%20light%2C%20cozy%20investigative%20mood%2C%20top%20down%20editorial%20photography%2C%20cream%20and%20brown%20palette%2C%20high%20detail&width=640&height=460&seq=gossip-expose-03&orientation=landscape",
    heat: "5.1k",
  },
  {
    id: "expose-4",
    title: "翻车现场：直播连麦失言",
    category: "翻车",
    excerpt: "一句口误被反复剪辑，完整回放与切片同时放出，供大家自行对照。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20spotlight%20falling%20on%20an%20empty%20wooden%20stage%20with%20red%20velvet%20curtain%2C%20minimal%20editorial%20photography%2C%20terracotta%20and%20gold%20tones%2C%20soft%20shadows%2C%20no%20people%2C%20high%20detail&width=640&height=460&seq=gossip-expose-04&orientation=landscape",
    heat: "4.9k",
  },
  {
    id: "expose-5",
    title: "被扒：兼职推荐链复盘",
    category: "被扒",
    excerpt: "从推荐人到收款方，社区画出了一张足够清楚的流程图供核对。",
    cover:
      "https://readdy.ai/api/search-image?query=Knotted%20red%20string%20on%20a%20cream%20notebook%20with%20a%20pencil%2C%20abstract%20connection%20concept%2C%20warm%20minimal%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20terracotta%20accents%2C%20high%20detail&width=640&height=460&seq=gossip-expose-05&orientation=landscape",
    heat: "4.3k",
  },
  {
    id: "expose-6",
    title: "黑历史：往届旧帖整理",
    category: "黑历史",
    excerpt: "把散落在各处的旧帖按主题归拢，附上可核对的公开链接。",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20old%20folded%20letters%20and%20archived%20paper%20documents%20tied%20with%20string%2C%20warm%20sepia%20and%20sand%20tone%2C%20minimal%20editorial%20still%20life%2C%20soft%20diffused%20light%2C%20no%20readable%20text%2C%20high%20detail&width=640&height=460&seq=gossip-expose-06&orientation=landscape",
    heat: "3.6k",
  },
];

export const discussions = [
  {
    id: "talk-1",
    author: "匿名同学·K7",
    badge: "投稿人",
    time: "8分钟前",
    topic: "社团经费",
    content:
      "那份表我旁边也有同学在传，但版本不太一样。建议先把两个版本并排贴出来再讨论，不然很容易越传越乱，最后谁也说不清。",
    likes: 268,
    replies: 46,
  },
  {
    id: "talk-2",
    author: "代号：夜灯",
    badge: "老吃瓜",
    time: "22分钟前",
    topic: "时间线",
    content:
      "把时间线拉直之后其实很清楚，中间那两小时的空白才是关键。谁在那段时间做了什么，目前没人给出说法，建议先别急着下结论。",
    likes: 197,
    replies: 33,
  },
  {
    id: "talk-3",
    author: "在读生·小A",
    badge: "新加入",
    time: "1小时前",
    topic: "宿舍矛盾",
    content:
      "希望大家理性一点，涉及具体人的内容还是交给能够核实的人去处理，我们就事论事就好，别把情绪发到陌生人身上。",
    likes: 154,
    replies: 58,
  },
];

export const faqs = [
  {
    q: "黑料学生上的内容都是真的吗？",
    a: "站内内容主要来自匿名投稿与社区整理，我们会明确标注「待核实 / 已核实 / 已澄清」三种状态。看到「待核实」的内容，请把它当作线索而不是结论，也欢迎补充可核对的材料。",
  },
  {
    q: "投稿需要提供什么材料？",
    a: "越具体越好：时间、地点、可核对的截图或聊天记录（请自行打码隐私信息）。没有直接材料的传闻我们一般只放入讨论区，不会作为实锤呈现。",
  },
  {
    q: "会公布真实姓名和联系方式吗？",
    a: "不会。站内一律使用化名与代号，任何涉及真实姓名、学号、联系方式、家庭住址等隐私信息的内容都不会被收录和展示。",
  },
  {
    q: "发现自己被误伤怎么办？",
    a: "可以在任意内容下方提交「澄清申请」，附带能够说明情况的材料。核对后我们会更新状态标记，并在原内容旁附上澄清说明。",
  },
  {
    q: "为什么有的内容会被下架？",
    a: "当内容涉及隐私泄露、无法核实且可能造成误伤，或当事人提供了有效澄清材料时，我们会下架或改为「已澄清」状态，处理记录可在社区公示中查看。",
  },
];

export const stats = [
  { value: "128,400+", label: "累计投稿" },
  { value: "3,271", label: "已核实条目" },
  { value: "42", label: "澄清处理" },
  { value: "24h", label: "平均核实用时" },
];

export const guidelines = [
  { icon: "ri-shield-check-line", title: "隐私信息一律打码", desc: "真实姓名、学号、联系方式与住址不会被收录或展示。" },
  { icon: "ri-scales-3-line", title: "先核实，再标注", desc: "每条内容都会标注核实状态，未证实的不当作结论。" },
  { icon: "ri-chat-voice-line", title: "允许当事人澄清", desc: "当事人可提交材料申请澄清，我们会同步更新原内容。" },
  { icon: "ri-hand-heart-line", title: "就事论事，不针对个人", desc: "讨论聚焦事件本身，不鼓励人身攻击与扩散隐私。" },
];

export const navLinks = [
  { label: "爆料速递", href: "#briefs" },
  { label: "实锤现场", href: "#stories" },
  { label: "翻车汇总", href: "#expose" },
  { label: "社区讨论", href: "#discussion" },
  { label: "投稿须知", href: "#trust" },
  { label: "常见问题", href: "#faq" },
];